import { useState } from "react";
import { FaTimes, FaCheck } from "react-icons/fa";

const SignatureModal = ({ isOpen, onClose, onSign, fullName }) => {
    const [name, setName] = useState(fullName);
    const [initials, setInitials] = useState("");
    const [error, setError] = useState("");

    if (!isOpen) return null;

    const handleSign = () => {
        if (!name.trim()) {
            setError("Please enter your full name.");
            return;
        }
        if (!initials.trim()) {
            setError("Please enter your initials to sign.");
            return;
        }
        if (initials.trim().length < 2) {
            setError("Please enter at least 2 characters for your signature.");
            return;
        }
        onSign(initials.trim(), name.trim());
        setInitials("");
        setName(fullName);
        setError("");
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-bold text-dependable">Sign Waiver</h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        <FaTimes />
                    </button>
                </div>

                <p className="text-sm text-gray-600 mb-4">
                    By signing below, you acknowledge that you have read, understood, and agree to be bound by the
                    terms of the Winterization Services Agreement. Your electronic signature is legally binding.
                </p>

                <div className="mb-4">
                    <label className="block text-sm font-semibold text-dependable mb-1">Your Full Name</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value);
                            setError("");
                        }}
                        className="w-full h-12 px-4 border focus:outline-none border-dependable-gold focus:ring-2 ring-dependable"
                    />
                </div>

                <div className="mb-4">
                    <label className="block text-sm font-semibold text-dependable mb-1">Type Your Initials</label>
                    <input
                        type="text"
                        value={initials}
                        onChange={(e) => {
                            setInitials(e.target.value);
                            setError("");
                        }}
                        placeholder="e.g. J.S."
                        maxLength={20}
                        className="w-full h-12 px-4 border focus:outline-none border-dependable-gold focus:ring-2 ring-dependable"
                        autoFocus
                    />
                    {initials && (
                        <div className="mt-2 border-b-2 border-dependable pb-2">
                            <p className="font-signature text-4xl text-dependable">{initials}</p>
                        </div>
                    )}
                    {error && <p className="text-red-700 text-sm mt-1">{error}</p>}
                </div>

                <div className="flex justify-end space-x-3">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-100"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSign}
                        className="px-4 py-2 bg-dependable text-white rounded hover:bg-dependable-green flex items-center"
                    >
                        <FaCheck className="mr-2" /> Sign
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SignatureModal;